<template>
    <b-modal
            :id="`vuelidateErrorDialog_${parent}`"
            title-html="<i class='fal fa-exclamation-circle'></i>&nbsp;&nbsp;Oeps, u bent iets vergeten"
            size="lg"
            ok-title="sluiten"
            ok-variant="success"
            ok-only
            @ok="closeModal"
            @hidden="closeModal"
            hide-header-close
    >
        <b-row>
            <b-col>
                <p>
                    U moet de volgende velden goed invullen:
                </p>
                <ul>
                    <base-multi-error-extractor v-bind="$attrs" style="margin-top: 1rem">
                        <template slot-scope="{ errorMessage }">
                            <li>{{ errorMessage }}</li>
                        </template>
                    </base-multi-error-extractor>
                </ul>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>
    import { templates } from 'vuelidate-error-extractor'

    export default {
        inheritAttrs: false,
        components: {
            baseMultiErrorExtractor: templates.multiErrorExtractor.baseMultiErrorExtractor
        },
        props: {
            state: {
                type: Boolean,
                default: false
            },
            parent: {
                type: String,
                default: 'App'
            }
        },
        watch: {
            state: function(val) {
                if(val) {
                    this.$bvModal.show(`vuelidateErrorDialog_${this.parent}`)
                } else {
                    this.$bvModal.hide(`vuelidateErrorDialog_${this.parent}`)
                }
            }
        },
        methods: {
            closeModal() {
                this.$emit('onClose')
            }
        }
    }
</script>

<!--
<template>
    <b-modal
            id="vuelidateErrorDialog"
            title-html="<i class='fa fa-exclamation'></i>&nbsp;&nbsp;Oeps, u bent iets vergeten"
            size="lg"
            ok-title="sluiten"
            ok-variant="success"
            ok-only
            @ok="$bvModal.hide('vuelidateErrorDialog')"
            hide-header-close
    >
        <b-row>
            <b-col>
                <p>
                    U moet de volgende velden goed invullen:
                </p>
                <ul>
                    <li v-for="item in fields" :key="item">
                        {{item}}
                    </li>
                </ul>
            </b-col>
            </b-col>
        </b-row>
    </b-modal>
</template>
<script>
    export default {
        props: {
            fields: {
                type: Array,
                default: []
            }
        },
        watch: {
            fields: function(val) {
                if(val.length) {
                    this.openModal()
                } else {
                    this.closeModal()
                }
            }
        },
        methods: {
            openModal() {
                this.$bvModal.show('vuelidateErrorDialog')
            },
            closeModal() {
                this.$bvModal.hide('vuelidateErrorDialog')
            }
        }
    }
</script>-->
